<template>
  <div id="websales-app">
    <ul class="skip-links">
      <li>
        <a href="#wb-cont" ref="skipLink" class="skip-link">{{ $t('Skip to main content') }}</a>
      </li>
    </ul>
    <VueAnnouncer />
    <appHeader />
    <div role="main">
      <router-view></router-view>
    </div>
    <appFooter />
  </div>
</template>

<script>
import appHeader from "./components/appHeader.vue";
import appFooter from "./components/appFooter.vue";
import { setDocumentLang } from "./util/i18n/document";
import { initWebex } from "./webex/webex";

export default {
  name: "app",
  components: {
    appHeader,
    appFooter,
  },
  mounted() {
    this.$watch(
      "$i18n.locale",
      (newLocale, oldLocale) => { 
        initWebex();
        // Check if language is same.
        if (newLocale === oldLocale) {
          return;
        }
        // Change document lang for screenreaders.
        setDocumentLang(newLocale);
      },
      { immediate: true }
    );
  },
  data() {
    return {
      errors: [],
      langs: ["en", "fr"],
      appFares: Object,
      submitStatus: null,
    };
  },
  methods: {},
  computed: {},
};
</script>

<style lang="scss">
body{
      font-size: 16px;
}
.skip-links {
  list-style: none;
}
.skip-link {
  white-space: nowrap;
  margin: 1em auto;
  top: 0;
  position: fixed;
  left: 50%;
  margin-left: -72px;
  opacity: 0;
}
.skip-link:focus {
  opacity: 1;
  background-color: white;
  padding: 0.5em;
  border: 1px solid black;
  z-index:10000;
}
h1 {
  font-weight: 300;
  font-size: 36px;
  color: $brand-primary;
  padding-top: 30px;
  margin-bottom: 30px;
  text-align: center;
}

h2,.h2 {
  color: $brand-primary;
  font-weight: 300;
}
.mrgn-rght-md{
  margin-right:15px;
}
#websales-app,
#websales-app-widget {
  margin-top: 55px;
  font-family: "Roboto", sans-serif;

  // Form elements
  legend{
    display: inline-block;
    max-width: 100%;
    font-weight: 300;
    font-size: 16px;
    color: #757070;
    border-bottom:unset;
    margin-bottom:5px;
  }
.form-control {
    background-color: #ffffff;
    border:1px solid #898989;
    -webkit-appearance: none;
    appearance: none;
    border-radius: 2px;
    color: #1F2123;
    height:50px;
  }

  select.form-control:not(#origin):not(#destination){
    background: url('./assets/select-dropdown-arrow.svg') no-repeat;
    background-position-x: 101%;
    background-position-y: center;
  }

  .btn-primary {
    border-radius: 2px;
    color: $brand-primary;
    background-color: #febc11;
    border-color: #febc11;
    transition: all 0.5s;
    padding-right: 25px;
    padding-left: 25px;

    &:hover {
      color: #fff;
      background-color: $brand-primary;
      border-color: $brand-primary;
    }

    &:focus {
      outline: 0;
      color: #fff;
      background-color: $brand-primary;
      border-color: $brand-primary;
      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(102, 175, 233, 0.6);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(102, 175, 233, 0.6);
    }
  }
  .btn-secondary{
    color: #fff;
    background-color: #00285e;
    border-color: #00285e;
  }
}
.btn{
  padding-top:14px;
  padding-bottom:14px;
  font-weight: bold;
  font-size:16px;
}

.btn-ghost {
  border: 1px solid #fff;
  color: #fff;
  border-radius: 2px;

  &:hover,
  &:focus {
    color: #000;
    background-color: #fff;
  }
}
.btn-reset{
  border-radius: 2px;
  color: $brand-highlight;
  background-color: #fff;
  border-color: none;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  padding-right: 25px;
  padding-left: 25px;

  &:hover,
  &:focus,
  &:active {
    color: #fff;
    background-color: $brand-primary;
    border-color: $brand-primary;
  }
}

.btn-ghost-white {
  border-radius: 2px;
  color: #fff;
  background-color: transparent;
  border-color: #fff;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  padding-right: 25px;
  padding-left: 25px;

  &:hover,
  &:focus,
  &:active {
    color: $brand-primary;
    background-color: #fff;
  }
}

.btn-ghost-yellow {
  border-radius: 2px;
  color: $brand-primary;
  background-color: #fff;
  border-color: #febc11;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  padding-right: 25px;
  padding-left: 25px;

  &:hover,
  &:focus,
  &:active {
    color: #fff;
    background-color: $brand-primary;
    border-color: $brand-primary;
  }
}

.btn-ghost-gray {
  border-radius: 2px;
  color: #424242;
  background-color: #fff;
  border-color: #424242;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  padding-right: 25px;
  padding-left: 25px;

  &:hover,
  &:focus,
  &:active {
    color: #fff;
    background-color: $brand-primary;
    border-color: $brand-primary;
  }
}

.btn-ghost-red {
  border-radius: 2px;
  color: #fff;
  background-color: #cb1700;
  border-color: #cb1700;

  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  padding-right: 25px;
  padding-left: 25px;

  &:hover,
  &:focus,
  &:active {
    color: #cb1700;
    background-color: #fff;
    border-color: #cb1700;
  }
}

.btn-ghost-blue {
  border-radius: 2px;
  color: $brand-primary;
  background-color: #fff;
  border-color: $brand-primary;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  padding-right: 25px;
  padding-left: 25px;

  &:hover,
  &:focus,
  &:active {
    color: #fff;
    background-color: $brand-primary;
    border-color: $brand-primary;
  }
}

.btn-ghost-grey {
  border-radius: 2px;
  color: #3c3c3b;
  background-color: #fff;
  border-color: #3c3c3b;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  padding-right: 25px;
  padding-left: 25px;

  &:hover,
  &:focus,
  &:active {
    color: #fff;
    background-color: #3c3c3b;
    border-color: #3c3c3b;
  }
}

.btn-grey {
  border-radius: 2px;
  color: #3c3c3b;
  background-color: #fff;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  padding-right: 10px;
  padding-left: 10px;
  margin-left: 15px;
  margin-right: 15px;

  &:hover,
  &:focus,
  &:active {
    color: #fff;
    background-color: #3c3c3b;
  }
}
.mini-widget--actions{
  margin-top:35px;
}

.label.form-error {
  color: #cb1700;
  background-color: transparent;
  margin-left: 10px;
  padding-left: 0px;
  font-size: 15px;

  a {
    color: #cb1700;
    font-weight: bold;
  }

  strong {
    font-weight: 300;
  }
}

.alert.alert-danger {
  h4 {
    background-color: #717171;
    color: #fff;
    font-weight: bold;
    font-size: 26px;
    padding: 20px 0px;

    span {
      display: block;
      position: relative;
      padding-left: 100px;

      img {
        position: absolute;
        top: -30px;
        left: 0px;
      }
    }
  }

  padding-left: 0px;
  padding-right: 0px;
  background-color: transparent;
  border-color: transparent;
  color: #cb1700;

  ul {
    padding-left: 110px;

    li {
      font-size: 18px;
      font-weight: 300;
    }
  }

  a {
    color: #cb1700;
    font-weight: bold;
  }
}

.alert-info{    color: #fff;
    background-color: $brand-primary;
    border-color: $brand-primary;
}


// Payment Pages
.payment-summary {
  border-color: $brand-primary;
  border-radius: 2px;
  background-color: #E2EDFC;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding: 20px 20px 10px 20px;
  font-size: 30px;
  font-weight: 500;
  color: #000;
  margin-bottom: 30px;
}

.payment-page {
  h2 {
    margin-bottom: 20px;
    border-top: 2px dashed #424242;
    padding-top: 20px;
  }

  label {
    font-weight: 300;
    color: #757070;
  }

  select {
    position: relative;
    padding-right: 20px;
    background-image: url("./assets/select-arrow.svg");
    background-repeat: no-repeat;
    background-position: center right 5px;
    background-size: 15px;
  }

  .form-control {
    background-color: #ffffff;
    border:1px solid #E4E4E4;
    -webkit-appearance: none;
    appearance: none;
    border-radius: 2px;
    color: #1F2123;
    height: 50px;
    padding: 13px 12px;
  }
}

@media screen and (max-width: 768px) {
  .alert.alert-danger ul {
    padding-left: 30px;
  }

  .label.form-error {
    white-space: pre-wrap;
    padding-left: 0px;
    margin-left: 0px;
  }
}
</style>
